<template>
  <div id="mall" class="store-page">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      :title="$t('title.mall')"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
      class="store-navbar"
    >
      <template #right>
        <img src="../assets/img/mall/mall_title_rank.png" class="mall_title_rank" @click="fetchShopRank"/>
      </template>
    </van-nav-bar>

    <!-- 分类标签栏 -->
    <div class="category-tabs">
      <van-tabs v-model="activeCategory" line-height="0" color="#ADADAD" title-active-color="#1A1A1A" title-inactive-color="#999">
        <van-tab :name="value.name" v-for="(value,j) in allCategories" :key="j">
          <template #title>
            <div class="tab-title-wrapper">
              <img class="tab-icon" :src="value.name == activeCategory ? value.select_icon : value.icon" :alt="value.label" />
              <div class="tab-text">{{ value.label }}</div>
            </div>
          </template>
        </van-tab>
        <van-tab></van-tab>
      </van-tabs>
      <div class="menu-btn" @click="showAllCategories">
        <van-icon name="bars" size="24" color="#666" />
      </div>
    </div>

    <!-- 子分类标签 -->
    <div class="sub-tabs" v-if="activeCategory != 'popular'">
      <div class="sub-tab-buttons">
        <div 
          class="sub-tab-button" 
          :class="{ active: activeSubCategory === '1' }"
          @click="activeSubCategory = '1'"
        >
          {{ $t('mall.latest') }}
        </div>
        <div 
          class="sub-tab-button" 
          :class="{ active: activeSubCategory === '2' }"
          @click="activeSubCategory = '2'"
        >
          {{ showSubTabs ? $t('mall.level') : $t('mall.hot_picks') }}
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content-area">

      <!-- popular 推荐  -->
      <div v-if="activeCategory == 'popular'">
        <!-- 横幅广告 -->
        <div class="banner-section">
          <van-swipe class="banner-swipe" :autoplay="3000" indicator-color="#FF69B4">
            <van-swipe-item>
              <div class="banner-item dress-up-banner">
                <img src="../assets/img/mall/mall_banner.png" alt="Dress-Up Mall" />
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- 本月上新 -->
        <div class="section-block" v-if="new_items.length > 0">
          <div class="section-header">
            <span class="section-title">{{ $t('mall.new_this_month') }}</span>
          </div>
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in new_items" :key="index" @click="showProductDetail(item)">
              <div class="product-image">
                <div v-if="isSvga(item.img)" :ref="'svga-new-' + index" class="svga-container"></div>
                <img v-else :src="item.img" :alt="item.name" />
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 头像框 -->
        <div class="section-block" v-if="avatar_frame_hot.length > 0">
          <div class="section-header">
            <span class="section-title">{{ $t('mall.avatar_frame') }}</span>
            <span class="section-more" @click="viewAll('avatar_frame')">{{ $t('mall.all') }} ></span>
          </div>
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in avatar_frame_hot" :key="index" @click="showProductDetail(item)" v-if="index <3">
              <div class="product-image">
                <!-- 头像框类型：显示用户头像 + 头像框 -->
                <div class="avatar-frame-image">
                  <img v-if="head_image" :src="head_image" alt="User Avatar" class="user-avatar" />
                  <div v-if="isSvga(item.img)" :ref="'svga-' + index" class="svga-container"></div>
                  <img v-else :src="item.img" :alt="item.name" class="avatar-frame-overlay" />
                </div>
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 座驾 -->
        <div class="section-block" v-if="car_hot.length > 0">
          <div class="section-header">
            <span class="section-title">{{ $t('mall.ride') }}</span>
            <span class="section-more" @click="viewAll('ride')">{{ $t('mall.all') }} ></span>
          </div>
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in car_hot" :key="index" @click="showProductDetail(item)" v-if="index <3">
              <div class="product-image">
                <div v-if="isSvga(item.img)" :ref="'svga-car-' + index" class="svga-container"></div>
                <img v-else :src="item.img" :alt="item.name" />
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Honor 荣誉 -->
        <div class="section-block" v-if="honor_hot.length > 0">
          <div class="section-header">
            <span class="section-title">{{ $t('mall.honor') }}</span>
            <span class="section-more" @click="viewAll('honor')">{{ $t('mall.all') }} ></span>
          </div>
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in honor_hot" :key="index" @click="showProductDetail(item)" v-if="index <3">
              <div class="product-image">
                <div v-if="isSvga(item.img)" :ref="'svga-honor-' + index" class="svga-container"></div>
                <img v-else :src="item.img" :alt="item.name" />
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Profile Card 贵宾卡 -->
        <div class="section-block" v-if="profile_card_hot.length > 0">
          <div class="section-header">
            <span class="section-title">{{ $t('mall.profile_card') }}</span>
            <span class="section-more" @click="viewAll('profile_card')">{{ $t('mall.all') }} ></span>
          </div>
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in profile_card_hot" :key="index" @click="showProductDetail(item)" v-if="index <3">
              <div class="product-image">
                <div v-if="isSvga(item.img)" :ref="'svga-profile_card-' + index" class="svga-container"></div>
                <img v-else :src="item.img" :alt="item.name" />
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- chat_bubble_hot 贵宾卡 -->
        <div class="section-block" v-if="chat_bubble_hot.length > 0">
          <div class="section-header">
            <span class="section-title">{{ $t('mall.chat_bubble') }}</span>
            <span class="section-more" @click="viewAll('chat_bubble')">{{ $t('mall.all') }} ></span>
          </div>
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in chat_bubble_hot" :key="index" @click="showProductDetail(item)" v-if="index <3">
              <div class="product-image">
                <div v-if="isSvga(item.img)" :ref="'svga-chat_bubble-' + index" class="svga-container"></div>
                <img v-else :src="item.img" :alt="item.name" />
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

         <!-- party_theme_hot 贵宾卡 -->
        <div class="section-block" v-if="party_theme_hot.length > 0">
          <div class="section-header">
            <span class="section-title">{{ $t('mall.party_theme') }}</span>
            <span class="section-more" @click="viewAll('party_theme')">{{ $t('mall.all') }} ></span>
          </div>
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in party_theme_hot" :key="index" @click="showProductDetail(item)" v-if="index <3">
              <div class="product-image">
                <div v-if="isSvga(item.img)" :ref="'svga-party_theme-' + index" class="svga-container"></div>
                <img v-else :src="item.img" :alt="item.name" />
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div v-if="activeCategory == 'honor'">
        <!-- honor 荣誉 -->
        <div class="section-block section-block-top">
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in activeSubCategory == 1 ? honor_new : honor_hot" :key="index" @click="showProductDetail(item)">
              <div class="product-image">
                <div v-if="isSvga(item.img)" :ref="'svga-honor1-' + index" class="svga-container"></div>
                <img v-else :src="item.img" :alt="item.name" />
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="activeCategory == 'rare_id'">
        <!--靓号 -->
        <div class="section-block section-block-top">
          <div class="product-grid lucky-grid" v-if="activeSubCategory == 1">
            <div class="product-item lucky-item" v-for="(item, index) in luck_num_new" :key="index" @click="showProductDetail(item)">
              <div class="product-image lucky-image">
                <img class="lucky-bg" src="../assets/img/mall/lucky_bg.png" alt="background" />
                <img class="lucky-ssr" src="../assets/img/mall/lucky_ssr.png" alt="SSR" />
                <div class="lucky-id-badge">
                  <span class="lucky-id-text">{{ item.name }}</span>
                </div>
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                  <img src="../assets/img/coin7.png" alt="coin" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="product-item1" v-for="(t, j) in luck_num_level" :key="j">
            <div class="product-item-title">{{ $t('mall.digits', { count: t.type }) }}</div>
            <div class="product-grid lucky-grid">
             
                <div class="product-item lucky-item" v-for="(item, index) in t.list" :key="index" @click="showProductDetail(item)">
                  <div class="product-image lucky-image">
                    <img class="lucky-bg" src="../assets/img/mall/lucky_bg.png" alt="background" />
                    <img class="lucky-ssr" src="../assets/img/mall/lucky_ssr.png" alt="SSR" />
                    <div class="lucky-id-badge">
                      <span class="lucky-id-text">{{ item.name }}</span>
                    </div>
                  </div>
                  <div class="product-info">
                    <div class="product-name">{{ item.name }}</div>
                    <div class="product-price">
                      <img src="../assets/img/coin7.png" alt="coin" />
                      <span>{{ item.coin }}</span>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          
        </div>
      </div>
      <div v-if="activeCategory == 'ride'">
        <!-- 座驾 -->
        <div class="section-block section-block-top">
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in activeSubCategory == 1 ? car_new : car_hot" :key="index" @click="showProductDetail(item)">
              <div class="product-image">
                <div v-if="isSvga(item.img)" :ref="'svga-ride-' + index" class="svga-container"></div>
                <img v-else :src="item.img" :alt="item.name" />
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div v-if="activeCategory == 'profile_card'">
        <!-- profile_card 贵宾卡 -->
        <div class="section-block section-block-top">
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in activeSubCategory == 1 ? profile_card_new : profile_card_hot" :key="index" @click="showProductDetail(item)">
              <div class="product-image">
                 <div v-if="isSvga(item.img)" :ref="'svga-profile_card1-' + index" class="svga-container"></div>
                <img v-else :src="item.img" :alt="item.name" />
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div v-if="activeCategory == 'avatar_frame'">
        <!-- 头像框 -->
        <div class="section-block section-block-top">
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in activeSubCategory == 1 ? avatar_frame_new : avatar_frame_hot" :key="index" @click="showProductDetail(item)">
              <div class="product-image">
                <!-- 头像框类型：显示用户头像 + 头像框 -->
                <div class="avatar-frame-image">
                  <img v-if="head_image" :src="head_image" alt="User Avatar" class="user-avatar" />
                  <div v-if="isSvga(item.img)" :ref="'svga-avatar_frame1-' + index" class="svga-container"></div>
                  <img v-else :src="item.img" :alt="item.name" class="avatar-frame-overlay" />
                </div>
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div v-if="activeCategory == 'party_theme'">
        <!-- party_theme 贵宾卡 -->
        <div class="section-block section-block-top">
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in activeSubCategory == 1 ? party_theme_new : party_theme_hot" :key="index" @click="showProductDetail(item)">
              <div class="product-image">
                <div v-if="isSvga(item.img)" :ref="'svga-party_theme1-' + index" class="svga-container"></div>
                <img v-else :src="item.img" :alt="item.name" />
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div v-if="activeCategory == 'chat_bubble'">
        <!-- chat_bubble 聊天泡泡 -->
        <div class="section-block section-block-top">
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in activeSubCategory == 1 ? chat_bubble_new : chat_bubble_hot" :key="index" @click="showProductDetail(item)">
              <div class="product-image">
                <div v-if="isSvga(item.img)" :ref="'svga-chat_bubble1-' + index" class="svga-container"></div>
                <img v-else :src="item.img" :alt="item.name" />
              </div>
              <div class="product-info">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-price">
                <img src="../assets/img/coin7.png" alt="New" />
                  <span>{{ item.coin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部余额栏 -->
    <div class="bottom-bar">
      <div class="balance-info">
        <div class="balance-item">
          <img src="../assets/img/coin7.png" alt="New" />
          <span class="balance-value">{{ diamondBalance }}</span>
          <van-icon name="add" size="22" color="#FF91F8" @click="recharge()"/>
        </div>
      </div>
      <van-button type="primary" class="cart-btn" @click="showCart">
        <img src="../assets/img/mall/mall_bag.png" alt="Cart" />
      </van-button>
    </div>

    <!-- 商品详情弹窗 -->
    <van-popup v-model="showDetail" position="bottom" class="detail-popup">
    
      <div class="detail-content">
        <div class="detail-preview">
          <div class="detail-header">
            <span class="detail-title">{{ getTypeLabel(currentProduct.type) }}</span>
            <img src="../assets/img/mall/mall_close.png" alt="Close" @click="ShareBtn" class="close-icon" />
          </div>
          <div class="preview-image">
            <div class="preview-image-lucky" v-if="currentProduct.type == -2">
              <img class="lucky-bg" src="../assets/img/mall/lucky_bg.png" alt="background" />
              <div class="lucky-id-badge">
                <span class="lucky-id-text">{{ currentProduct.name }}</span>
              </div>
            </div>
            <!-- 头像框类型：显示用户头像 + 头像框 -->
            <div v-else-if="currentProduct.type == 0" class="avatar-frame-image">
              <img v-if="head_image" :src="head_image" alt="User Avatar" class="user-avatar1" />
              <div v-if="isSvga(currentProduct.svga)" ref="svga-detail" class="svga-container-detail"></div>
              <img v-else :src="currentProduct.img" :alt="currentProduct.name" class="avatar-frame-overlay" />
            </div>
            <div v-else-if="isSvga(currentProduct.svga)" ref="svga-detail" class="svga-container-detail"></div>
            <img v-else :src="currentProduct.img" />
          </div>
        </div>
        <div class="detail-info">
          <div class="detail-name">{{ currentProduct.name }}</div>
          <div class="info-card">
            <div class="info-row">
              <span class="info-label">{{ $t('mall.validity_period') }}</span>
              <div class="validity-tag">{{ currentProduct.day > 0 ? currentProduct.day + ' ' + $t('mall.days') : $t('mall.permanent') }}</div>
            </div>
            <div class="info-row" v-if="currentProduct.type != -2">
              <span class="info-label">{{ $t('mall.gift_to_friends') }}</span>
              <div v-if="currentProduct.give_user_id" class="selected-user" @click="selectFriends">
                <img :src="currentProduct.give_user_head_image" class="selected-user-avatar" />
                <span class="selected-user-name">{{ currentProduct.give_user_nick_name }}</span>
              </div>
              <span v-else class="info-link" @click="selectFriends">{{ $t('mall.select_friends') }} &gt;</span>
            </div>
            <div class="info-row">
              <span class="info-label">{{ $t('mall.payment_method') }}</span>
              <div class="payment-methods">
                <div class="payment-pill" :class="{ active: payMethod === 'diamond' }" @click="payMethod = 'diamond'">
                    <img src="../assets/img/coin7.png" alt="New" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-footer">
            <div class="footer-balance">
               <img src="../assets/img/coin7.png" alt="New" />
              <span class="footer-amount">{{ currentProduct.coin }}</span>
            </div>
            <van-button type="primary" class="buy-btn" @click="purchase">
              {{ $t('mall.go_to_recharge') }}
              <div class="short-amount" v-if="needRecharge">{{ $t('mall.short') }}  <img src="../assets/img/coin7.png" alt="New" /> {{ shortageAmount }}</div>
            </van-button>
          </div>
      </div>
     
    </van-popup>

    <!-- 全部类别弹窗 -->
    <van-popup v-model="showCategoryPopup" position="top" class="category-panel">
      <div class="popup-header">
        <van-icon name="arrow-left" @click="showCategoryPopup = false" />
        <span class="title">{{ $t('title.mall') }}</span>
         <img src="../assets/img/mall/mall_title_rank.png" class="mall_title_rank"  @click="fetchShopRank"/>
      </div>
      <div class="popup-content">
        <div class="category-grid">
          <div class="category-item" v-for="item in allCategories" :key="item.name" @click="selectCategory(item)">
            <img class="category-icon" :src="item.name == activeCategory ? item.select_icon : item.icon" :alt="item.label"/>
            <div :class="item.name == activeCategory ? 'category-name-active' : 'category-name'">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 商城排行榜弹窗 -->
    <van-popup v-model="showRankPopup" class="rank-popup" :close-on-click-overlay="true">
      <div class="rank-content">
        <div class="rank-content-title-bg">
            <img :src="rankList[0].head_image" alt="Rank" class="rank-content-title-bg-avatar" v-if="rankList.length"/>
          <img src="../assets/img/mall/mall_rank_popup_title_img2.png" alt="Rank" class="rank-content-title-bg-heard"/>
        </div>
        <img src="../assets/img/mall/mall_rank_popup_title_wen.png" alt="Rank" class="rank-content-title-bg-wen" @click="showRankRule = true"/>
         <div class="rank-content-top1">
            <div class="rank-content-top1-name" v-if="rankList.length">{{ rankList[0].nick_name }} <img :src="rankList[0].country_img" alt="New" /></div>
            <div class="rank-content-top1-coin" v-if="rankList.length"><img src="../assets/img/coin7.png" alt="New" /> {{ rankList[0].consumption_amount }}</div>
              <div class="rank-content-top1-seach">
                <div class="rank-time-info">
                  <div class="rank-countdown" v-if="rankType === 'today'">
                    <img src="../assets/img/mall/mall_rank_popup_title_title.png">
                    <span> <van-count-down :time="countdownTime" /></span>
                  </div>
                  <div class="rank-today" @click="onClickToday">
                    <img src="../assets/img/mall/mall_rank_popup_title_type.png">
                    <span>{{ rankType === 'today' ? 'Today' : 'Yesterday' }}</span>
                  </div>
                </div>
              </div>
         </div>
        <!-- 排行榜列表 -->
        <div class="rank-list">
          <div 
            v-for="(item, index) in rankList" 
            :key="index" 
            class="rank-item"
            :class="{ 'my-rank': item.isMe }"
            v-if="index > 0"
          >
            <div class="rank-number" :class="'rank-' + (index + 1)">{{ index + 1 }}</div>
            <img :src="item.head_image" class="rank-item-avatar" />
            <div class="rank-item-info">
              <div class="rank-item-name">{{ item.nick_name }} <img :src="item.country_img" alt="New" /></div>
            </div>
            <div class="rank-item-coins">
              <img src="../assets/img/coin7.png" alt="coin" />
              <span>{{ item.consumption_amount }}</span>
            </div>
          </div>
        </div>
         <div class="rank-content-close">
           <van-icon name="close" size="30" color="#bababa" @click="showRankPopup = false" />
        </div>
      </div>
    </van-popup>

    <!-- 排行榜规则说明弹窗 -->
    <van-popup v-model="showRankRule" class="rank-rule-popup" :close-on-click-overlay="true">
      <div class="rank-rule-content-top">
        <div class="rank-rule-content">
           <div class="rank-rule-title-banner">
            <span class="rank-rule-title-text">{{ $t('mall.rank_rule_title') }}</span>
          </div>
          <div class="rank-rule-question-icon" @click="showRankRule = false">
            <van-icon name="clear" size="28" color="#B388FF" />
          </div>
          <div class="rank-rule-scroll-content" v-html="rules"> </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import { Dialog, DatetimePicker } from 'vant'
import SVGA from "svgaplayerweb";
import { judgeIosAndroid } from '@/assets/js/models.js'

export default {
  data() {
    return {
      document_title: '',
      activeCategory: 'popular',
      activeSubCategory: '1',
      showSubTabs: false,
      showDetail: false,
      showCategoryPopup: false,
      currentProduct: {},
      payMethod: 'diamond',
      // 余额信息
      diamondBalance: 0,
      goldBalance: 0,
      // 所有分类（基础数据，不含多语言）
      allCategoriesBase: [
        { name: 'popular', labelKey: 'mall.popular', icon: require('@/assets/img/mall/mall_tab_icon_1_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_1_2.png') },
        { name: 'honor', labelKey: 'mall.honor', icon: require('@/assets/img/mall/mall_tab_icon_2_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_2_2.png') },
        { name: 'rare_id', labelKey: 'mall.rare_id', icon: require('@/assets/img/mall/mall_tab_icon_3_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_3_2.png') },
        { name: 'ride', labelKey: 'mall.ride', icon: require('@/assets/img/mall/mall_tab_icon_4_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_4_2.png') },
        { name: 'profile_card', labelKey: 'mall.profile_card', icon: require('@/assets/img/mall/mall_tab_icon_5_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_5_2.png') },
        { name: 'avatar_frame', labelKey: 'mall.avatar_frame', icon: require('@/assets/img/mall/mall_tab_icon_6_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_6_2.png') },
        { name: 'party_theme', labelKey: 'mall.party_theme', icon: require('@/assets/img/mall/mall_tab_icon_7_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_7_2.png') },
        { name: 'chat_bubble', labelKey: 'mall.chat_bubble', icon: require('@/assets/img/mall/mall_tab_icon_8_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_8_2.png') }
      ],    
      svgaShow: false,
      shop_show: false,
      buy_one: {},
      coin_img: '',
      is_submit: true,
      svip_title: '',
      discount_rate: '',
      new_items: [],
      car_hot: [],
      car_new: [],
      avatar_frame_hot: [],
      avatar_frame_new: [],
      honor_hot: [],
      honor_new: [],
      profile_card_hot: [],
      profile_card_new: [],
      party_theme_hot: [],
      party_theme_new: [],
      chat_bubble_hot: [],
      chat_bubble_new: [],
      luck_num_new: [],
      luck_num_level: [],
      head_image: '', // 用户头像
      // 排行榜相关
      showRankPopup: false,
      showRankRule: false,
      countdownTime: 0,
      rankType: 'today', // 'today' 或 'yesterday'
      rankList: [],
      countdownTimer: null, // 定时器
      rankLoading: false, // 排行榜加载状态
      rules: '', // 排行榜规则
    }
  },
  created() {
    this.document_title = this.$t('title.shop')
    this.loadProducts()
    
    // 计算今日剩余秒数
    this.updateCountdown();
    // 每秒更新一次倒计时
    this.countdownTimer = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  },
  mounted() {
    // 在组件挂载后设置最后一个tab的样式
    this.$nextTick(() => {
      this.setLastTabStyle()
    })
    
    // 检查是否需要打开商品详情弹框(从选择赠送对象页面返回)
    if (this.$route.query.openDetail === '1' && this.$route.query.product) {
      try {
        const product = JSON.parse(this.$route.query.product)
        if (product) {
          this.currentProduct = product
          this.payMethod = 'diamond'
          this.showDetail = true
          
          // 如果是 SVGA 格式，延迟播放
          if (this.isSvga(product.svga)) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.playSvga(product.svga, 'svga-detail')
              }, 300)
            })
          }
        }
        // 清除路由参数中的标记
        this.$router.replace({
          query: {
            uid: this.$route.query.uid,
            token: this.$route.query.token
          }
        })
      } catch (e) {
        console.error('解析商品信息失败:', e)
      }
    }
  },
  computed: {
    // 所有分类（带多语言）
    allCategories() {
      return this.allCategoriesBase.map(item => ({
        ...item,
        label: this.$t(item.labelKey)
      }))
    },
    totalBalance() {
      return this.diamondBalance.toLocaleString()
    },
    needRecharge() {
      const priceStr = this.currentProduct.coin || '0'
      const price = parseInt(priceStr.replace(/,/g, ''))
      console.log(this.payMethod)
       console.log('Price:', price)
      console.log('diamondBalance:', this.diamondBalance)
      if (this.payMethod === 'diamond') {
        return price > this.diamondBalance
      } else {
        return price > this.goldBalance
      }
    },
    shortageAmount() {
      const priceStr = this.currentProduct.coin || '0'
      const price = parseInt(priceStr.replace(/,/g, ''))
      if (this.payMethod === 'diamond') {
        return (price - this.diamondBalance).toLocaleString()
      } else {
        return (price - this.goldBalance).toLocaleString()
      }
    }
  },
  watch: {
    activeCategory(newVal) {
      // 分类切换后重新设置样式
      this.$nextTick(() => {
        this.setLastTabStyle()
        // 分类切换后播放对应分类的 SVGA
        this.playCategorySvga(newVal)
      })
    },
    activeSubCategory(newVal) {
      // 子分类切换后播放对应分类的 SVGA
      this.$nextTick(() => {
        this.playCategorySvga(this.activeCategory)
      })
    }
  },
  components: {
    [Dialog.name]: Dialog,
    [DatetimePicker.name]: DatetimePicker
  },
  methods: {
    ShareBtn() {
      // 选择好友赠送 - 跳转到选择赠送对象页面
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({
        path: '/select_share_friends',
        query: {
          uid: uid,
          token: token,
          product: JSON.stringify(this.currentProduct)
        }
      })
    
    },
    getTypeLabel(type) {
      const typeMap = {
        '-2': this.$t('mall.rare_id'),
        '-1': this.$t('mall.ride'),
        '0': this.$t('mall.avatar_frame'),
        '1': this.$t('mall.honor'),
        '2': this.$t('mall.profile_card'),
        '3': this.$t('mall.party_theme'),
        '4': this.$t('mall.chat_bubble')
      }
      return typeMap[type] || ''
    },
    loadProducts() {
      // 加载商品数据
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=get_mall_list", {
        params: {
          user_id: uid,
          token: token
        }
      }).then(res => {
        if (res.data.status === 1) {
          // 处理返回的商品数据
          this.new_items = res.data.data.new_items
          this.car_hot = res.data.data.car_hot
          this.car_new = res.data.data.car_new
          this.avatar_frame_hot = res.data.data.avatar_frame_hot
          this.avatar_frame_new = res.data.data.avatar_frame_new
          this.honor_hot = res.data.data.honor_hot
          this.honor_new = res.data.data.honor_new
          this.profile_card_hot = res.data.data.profile_card_hot
          this.profile_card_new = res.data.data.profile_card_new
          this.party_theme_hot = res.data.data.party_theme_hot
          this.party_theme_new = res.data.data.party_theme_new
          this.chat_bubble_hot = res.data.data.chat_bubble_hot
          this.chat_bubble_new = res.data.data.chat_bubble_new
          this.luck_num_new = res.data.data.luck_num_new
          this.luck_num_level = res.data.data.luck_num_level
          this.diamondBalance = res.data.data.diamond_balance
          // 获取用户头像（用于头像框显示）
          if (res.data.data.head_image) {
            this.head_image = res.data.data.head_image
          }
          
          // 加载排行榜数据
          if (res.data.data.rank_list) {
            this.rankList = res.data.data.rank_list
          }
          
          // 播放 SVGA 动画
          this.$nextTick(() => {
            // 播放本月上新的 SVGA
            this.new_items.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-new-' + index)
              }
            })
            // 播放头像框的 SVGA
            this.avatar_frame_hot.forEach((item, index) => {
              if (index < 3 && this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-' + index)
              }
            })
            // 播放头像框分类页面的 SVGA
            this.avatar_frame_hot.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-avatar_frame1-' + index)
              }
            })
            this.avatar_frame_new.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-avatar_frame1-' + index)
              }
            })
            // 播放座驾分类页面的 SVGA
            this.car_hot.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-ride-' + index)
              }
            })
            this.car_new.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-ride-' + index)
              }
            })
            // 播放荣誉分类页面的 SVGA
            this.honor_hot.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-honor1-' + index)
              }
            })
            this.honor_new.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-honor1-' + index)
              }
            })
            // 播放贵宾卡分类页面的 SVGA
            this.profile_card_hot.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-profile_card1-' + index)
              }
            })
            this.profile_card_new.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-profile_card1-' + index)
              }
            })
          })
          
          // 数据加载完成后，检查路由参数是否指定了装扮类型和ID
          this.$nextTick(() => {
            this.handleRouteDressUpParams()
          })
        }
      }).catch(err => {
        console.error('Failed to load products:', err)
      })
    },
    /**
     * 根据路由参数定位到指定装扮类型并打开购买详情弹窗
     * 路由参数：
     *   dress_up_type: 装扮类型（-2靓号, -1座驾, 0头像框, 1荣誉, 2个人资料卡, 3派对主题, 4聊天气泡）
     *   dress_up_id: 装扮ID
     */
    handleRouteDressUpParams() {
      const dressUpType = this.$route.query.dress_up_type
      const dressUpId = this.$route.query.dress_up_id
      
      if (dressUpType === undefined || dressUpType === null) {
        return
      }
      
      const typeNum = parseInt(dressUpType)
      
      // 装扮类型 -> 分类标签映射
      const typeToCategory = {
        '-2': 'rare_id',
        '-1': 'ride',
        '0': 'avatar_frame',
        '1': 'honor',
        '2': 'profile_card',
        '3': 'party_theme',
        '4': 'chat_bubble'
      }
      
      const category = typeToCategory[String(typeNum)]
      if (!category) {
        console.warn('Unknown dress_up_type:', dressUpType)
        return
      }
      
      // 切换到对应分类标签
      this.activeCategory = category
      this.activeSubCategory = '1'
      
      // 如果未指定具体装扮ID，仅切换标签页
      if (!dressUpId) {
        return
      }
      
      const targetId = parseInt(dressUpId)
      
      // 根据类型从已加载数据中查找对应装扮
      const dataListMap = {
        'honor': { hot: this.honor_hot, new: this.honor_new },
        'profile_card': { hot: this.profile_card_hot, new: this.profile_card_new },
        'party_theme': { hot: this.party_theme_hot, new: this.party_theme_new },
        'chat_bubble': { hot: this.chat_bubble_hot, new: this.chat_bubble_new },
        'ride': { hot: this.car_hot, new: this.car_new },
        'avatar_frame': { hot: this.avatar_frame_hot, new: this.avatar_frame_new },
        'rare_id': { hot: this.luck_num_new, new: this.luck_num_new }
      }
      
      const dataLists = dataListMap[category]
      if (!dataLists) return
      
      // 在热门和最新列表中查找目标装扮
      let targetItem = null
      const allItems = [...(dataLists.hot || []), ...(dataLists.new || [])]
      for (const item of allItems) {
        if (parseInt(item.id) === targetId) {
          targetItem = item
          break
        }
      }
      
      if (targetItem) {
        // 延迟打开弹窗，确保页面渲染完成
        setTimeout(() => {
          this.showProductDetail(targetItem)
        }, 500)
      } else {
        console.warn('Dress up item not found, type:', dressUpType, 'id:', dressUpId)
        Toast(this.$t('mall.item_not_found') || 'Item not found')
      }
    },
    showProductDetail(product) {
      this.currentProduct = { ...product }
      this.payMethod = 'diamond'
      this.showDetail = true
      
      console.log('Show product detail:', product)
      console.log('Is SVGA:', this.isSvga(product.svga))
      
      // 如果是 SVGA 格式，延迟播放
      if (this.isSvga(product.svga)) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.playSvga(product.svga, 'svga-detail')
          }, 300)
        })
      }
    },
    selectFriends() {
      // 选择好友赠送 - 跳转到选择赠送对象页面
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({
        path: '/select_friends',
        query: {
          uid: uid,
          token: token,
          product: JSON.stringify(this.currentProduct)
        }
      })
    },
    viewAll(category) {
      // 查看全部 - 切换到对应分类
      this.activeCategory = category
      this.activeSubCategory = '1'  // 重置为最新
      this.$nextTick(() => {
        this.setLastTabStyle()
        this.playCategorySvga(category)
      })
    },
    recharge() {
      // 充值   跳转到充值页面
      window.location.href="live://live?action=Recharge"
    },
    showCart() {
       const uid = this.$route.query.uid
      const token = this.$route.query.token
       this.$router.push({
        path: '/mall_my',
        query: { uid: uid, token: token,source: 'h5' }
      })
    },
    purchase() {
      if (this.needRecharge) {
        this.recharge()
      } else {
        this.confirmPurchase()
      }
    },
    confirmPurchase() {
      console.log(this.currentProduct)
      Dialog.confirm({
        title: this.$t('mall.confirm_purchase'),
        message: this.$t('mall.purchase_confirm_message', { name: this.currentProduct.name, coin: this.currentProduct.coin })
      }).then(() => {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=pay", {
          params: {
            user_id: uid,
            token: token,
            id: this.currentProduct.recharge_id,
            shop_id: this.currentProduct.id,
            shop_type: this.currentProduct.type,
            pay_method: this.payMethod,
            receive_uid: this.currentProduct.give_user_id || 0
          }
        }).then(res => {
          Toast(res.data.error)
          if (res.data.status == 1) {
            this.showDetail = false
            // 更新余额
            if (this.payMethod === 'diamond') {
              this.diamondBalance -= parseInt(this.currentProduct.coin.replace(/,/g, ''))
            } else {
              this.goldBalance -= parseInt(this.currentProduct.coin.replace(/,/g, ''))
            }
          }
        }).catch(err => {
          Toast.fail(this.$t('mall.purchase_failed') + ' ' + err)
          console.error(err)
        })
      }).catch(() => {
        // 取消购买
      })
    },
    onClickLeft() {
      window.location.href = "bogolive://exit"
    },
    onClickRight() {
    },
    showAllCategories() {
      this.showCategoryPopup = true
    },
    selectCategory(category) {
      this.activeCategory = category.name
      this.showCategoryPopup = false
    },
    isWebP(url) {
      if (!url) return false
      const cleanUrl = url.split('?')[0].split('#')[0]
      const extension = cleanUrl.split('.').pop().toLowerCase()
      return extension === 'webp'
    },
    isSvga(url) {
      if (!url) return false
      const cleanUrl = url.split('?')[0].split('#')[0]
      const extension = cleanUrl.split('.').pop().toLowerCase()
      return extension === 'svga'
    },
    playSvga(url, refName) {
      if (!url || !this.isSvga(url)) return
      
      this.$nextTick(() => {
        const container = this.$refs[refName]
        // 处理单个元素或数组
        const targetContainer = Array.isArray(container) ? container[0] : container
        if (!targetContainer) {
          console.log('SVGA container not found:', refName)
          return
        }
        
        console.log('Playing SVGA:', url, 'in container:', refName)
        
        try {
          const player = new SVGA.Player(targetContainer)
          const parser = new SVGA.Parser()
          parser.load(url, (videoItem) => {
            if (!videoItem) {
              console.error('SVGA load failed:', url)
              return
            }
            console.log('SVGA loaded successfully:', videoItem)
            player.setVideoItem(videoItem)
            player.startAnimation()
          })
        } catch (error) {
          console.error('SVGA play error:', error)
        }
      })
    },
    playCategorySvga(category) {
      // 根据分类播放 SVGA 动画
      this.$nextTick(() => {
        switch(category) {
          case 'popular':
            // popular 页面已经在 loadProducts 中处理
            break
          case 'avatar_frame':
            // 头像框分类页面
            const avatarFrameList = this.activeSubCategory == '1' ? this.avatar_frame_new : this.avatar_frame_hot
            avatarFrameList.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-avatar_frame1-' + index)
              }
            })
            break
          case 'ride':
            // 座驾分类页面
            const carList = this.activeSubCategory == '1' ? this.car_new : this.car_hot
            carList.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-ride-' + index)
              }
            })
            break
          case 'honor':
            // 荣誉分类页面
            const honorList = this.activeSubCategory == '1' ? this.honor_new : this.honor_hot
            honorList.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-honor1-' + index)
              }
            })
            break
          case 'profile_card':
            // 贵宾卡分类页面
            const profileCardList = this.activeSubCategory == '1' ? this.profile_card_new : this.profile_card_hot
            profileCardList.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-profile_card1-' + index)
              }
            })
            break
          case 'rare_id':
            break
        }
      })
    },
    setLastTabStyle() {
      // 获取所有van-tab元素
      const tabs = this.$el.querySelectorAll('.van-tab')
      if (tabs.length > 0) {
        // 获取最后一个tab
        const lastTab = tabs[tabs.length - 1]
        // 直接设置内联样式
        lastTab.style.flexBasis = '15%'
        lastTab.style.minWidth = '15%'
        lastTab.style.maxWidth = '15%'
        lastTab.style.width = '15%'
      }
    },
    fetchShopRank() {
      // 防止重复请求
      if (this.rankLoading) return;
      this.showCategoryPopup = false;
      this.rankLoading = true;
      const uid = this.$route.query.uid;
      const token = this.$route.query.token;
          
      // 显示加载状态
      this.showRankPopup = true;
          
      axios.get(this.baseUrlApi + this.baseUrlPath + '?ctl=prop_mall&act=get_prop_shop_rank', {
        params: {
          user_id: uid,
          token: token,
          rank_type: this.rankType
        }
      }).then(res => {
        if (res.data.status === 1 && res.data.data && res.data.data.rank_list) {
          this.rankList = res.data.data.rank_list;
          this.rules = res.data.data.rules || '';
        } else {
          this.rankList = [];
          Toast(res.data.error || this.$t('mall.rank_load_failed'));
        }
      }).catch(err => {
        console.error('Failed to load shop rank:', err);
        this.rankList = [];
        Toast.fail(this.$t('mall.rank_load_failed'));
      }).finally(() => {
        this.rankLoading = false;
      });
    },
    onClickToday() {
      const now = new Date();
      // 切换今日/昨日
      if (this.rankType === 'today') {
        // 切换到昨日
        now.setDate(now.getDate() - 1);
        this.rankType = 'yesterday';
      } else {
        // 切换到今日
        this.rankType = 'today';
      }
      this.fetchShopRank();
    },
    
    updateCountdown() {
      // 计算到今晚12点（24:00:00）的剩余秒数
      const now = new Date();
      const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      const remaining = Math.floor((endOfDay - now));
      this.countdownTime = remaining > 0 ? remaining : 0;
    }
  },
  beforeDestroy() {
    // 清理定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/mall.vue